<template>
    <div class="b-table-sticky-header table-responsive mt-1" style="max-height:364px;">
        <b-table-simple
            no-border-collapse
            striped
            small
            class="mb-0"
        >
            <b-thead>
                <tr>
                    <th
                        v-for="(header, headerIdx) in headers"
                        :key="headerIdx"
                        :style="{ 'width': headerIdx > 0 ? '20%' : '' }"
                        style="position: sticky;top:-1px;z-index:2;"
                        :class="{'text-right': headerIdx > 0}"
                    >
                        {{ header }}
                    </th>
                </tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(item, nodeIdx) in twoMonthProducts" :key="nodeIdx">
                    <b-td>
                        {{ item.productCode }}
                    </b-td>
                    <b-td class="text-right">
                        {{ getPrevMonthCostByProductCode(item.productCode) != '-' ? $_getDollar(getPrevMonthCostByProductCode(item.productCode)) : '-'}}
                    </b-td>
                    <b-td class="text-right font-weight-bold">
                        <a @click="emitDetailLayer(item.productCode)" v-if="getThisMonthCostByProductCode(item.productCode) != '-'">
                            {{ $_getDollar(getThisMonthCostByProductCode(item.productCode)) }}
                        </a>
                        <span v-if="getThisMonthCostByProductCode(item.productCode) == '-'">-</span>
                    </b-td>
                    <b-td class="text-right" v-html="item.html"></b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
    </div>
</template>

<script>
import { computed, toRefs, getCurrentInstance } from '@vue/composition-api'
export default {
    props: {
        thisMonthProducts: {
            type: Array,
            default: function () {
                return []
            }
        },
        lastMonthProducts: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const headers = ['Product', 'Prev', 'This month', '']
        const { thisMonthProducts, lastMonthProducts } = toRefs(props)
        const getPrevMonthCostByProductCode = productCode => (lastMonthProducts.value.find(item => item.productCode === productCode) && lastMonthProducts.value.find(item => item.productCode === productCode).cost) || '-'
        const getThisMonthCostByProductCode = productCode => (thisMonthProducts.value.find(item => item.productCode === productCode) && thisMonthProducts.value.find(item => item.productCode === productCode).cost) || '-'
        const getTrendByProductCode = productCode => {
            const thisMonthCostByProductCode = getThisMonthCostByProductCode(productCode)
            const prevMonthCostByProductCode = getPrevMonthCostByProductCode(productCode)
            let thisMonthCost = thisMonthCostByProductCode !== '-' ? thisMonthCostByProductCode : 0
            let prevMonthCost = prevMonthCostByProductCode !== '-' ? prevMonthCostByProductCode : 0

            let diffCost = thisMonthCost - prevMonthCost

            let output = (diffCost < 0 ? '-' : '+') + vm.$_getDollar(Math.abs(diffCost))

            if (prevMonthCostByProductCode !== '-' && prevMonthCostByProductCode !== 0) {
                output += ' <small>(' + Math.round(((thisMonthCost / prevMonthCost) - 1) * 1000) / 10 + '%)</small>'
            }
            return output
        }

        const twoMonthProducts = computed(() => {
            return thisMonthProducts.value.map(item => item.productCode)
                .concat(lastMonthProducts.value.map(item => item.productCode))
                .reduce((accumulator, currentValue) => {
                    if (accumulator.indexOf(currentValue) < 0) {
                        accumulator.push(currentValue)
                    }
                    return accumulator
                }, [])
                .map(productCode => ({
                    productCode,
                    html: getTrendByProductCode(productCode)
                }))
                .filter((obj, pos, arr) => {
                    return arr.indexOf(obj) === pos
                })
        })

        const emitDetailLayer = productCode => context.emit('detail-layer', productCode)
        return {
            headers,
            twoMonthProducts,
            getPrevMonthCostByProductCode,
            getThisMonthCostByProductCode,
            emitDetailLayer
        }
    }
}
</script>

<style>

</style>
